export default __webpack_public_path__ + "static/8-tips-for-saving-money-for-your-next-holiday-budget-7965b7fd1b91da1691cf01e182b1fb1b.jpg";